import svgLogoRegistry from '../data/organization-logos-svg.json';

/**
 * Get organization logo URL with intelligent fallbacks
 * @param {Object} org - Organization object with acronym, service_branch, parent_org_id
 * @param {Array} allOrgs - All organizations for parent lookup
 * @returns {string} Logo data URI
 */
export const getOrgLogo = (org, allOrgs = []) => {
  if (!org) return svgLogoRegistry.logos.default;

  const { logos } = svgLogoRegistry;

  // 1. Try exact acronym match
  if (org.acronym && logos[org.acronym]) {
    return logos[org.acronym];
  }

  // 2. Try service branch logo
  if (org.service_branch && logos[org.service_branch]) {
    return logos[org.service_branch];
  }

  // 3. Try parent organization logo (recursive)
  if (org.parent_org_id && allOrgs.length > 0) {
    const parent = allOrgs.find(o => o.id === org.parent_org_id);
    if (parent) {
      return getOrgLogo(parent, allOrgs);
    }
  }

  // 4. Default to generic logo
  return logos.default;
};

/**
 * Preload logos to avoid render flicker
 * @param {Array} organizations - Array of org objects
 * @returns {Promise} Resolves when all logos are loaded
 */
export const preloadLogos = async (organizations = []) => {
  const uniqueUrls = new Set();

  organizations.forEach(org => {
    const logoUrl = getOrgLogo(org, organizations);
    if (logoUrl) uniqueUrls.add(logoUrl);
  });

  return Promise.all(
    Array.from(uniqueUrls).map(url => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = resolve; // Don't fail if logo can't load, just use fallback
        img.src = url;
      });
    })
  );
};

export default svgLogoRegistry;
